import axios from "axios";

const api = axios.create({
    baseURL: process.env.VUE_APP_NODE_API_BASE_URL + process.env.VUE_APP_NODE_API_END_POINT,
    headers:{
        "Content-Type": "application/json",
    }
});
api.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        if (error.response.status !== 404 && error.response.status !== 500){
            console.error('Response Error:', error.response);
        }
        return Promise.reject(error);
    }
);

class ChatService {
    getMessagesPageSize(){
        return 20;
    }

    getRecentPageSize(){
        return 10;
    }

    async getClientRecentChats(locationId, clientId, roomType, search, page){
        return await api.get(`chat/client-recent?locationId=${locationId}&clientId=${clientId}&roomType=${roomType}&search=${search}&page=${page}&pageSize=${this.getRecentPageSize()}`);
    }

    async getClientChatRoomMessagesByChatRoomId(locationId, clientId, chatRoomId, page){
        return await api.get(`chat/client/room/messages?locationId=${locationId}&clientId=${clientId}&crId=${chatRoomId}&page=${page}&pageSize=${this.getMessagesPageSize()}`)
    }
    async postClientSendMessage(locationId, clientId, payload){
        return await api.post(`chat/send-message?locationId=${locationId}&clientId=${clientId}`, payload);
    }

    async postClientMessageRead(locationId, payload){
        return await api.post(`chat/client/mark-read?locationId=${locationId}`, payload);
    }


    async postClientAllMessageRead(locationId, payload){
        return await api.post(`chat/client/mark-read-all?locationId=${locationId}`, payload);
    }

    
}

export default new ChatService;